import React, { useEffect, useMemo, useState } from 'react';
import '../../../../Stylesheets/Profile/ProfilePage.css';
import { FaUser, FaCog, FaCreditCard } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

const ProfilePage = () => {
  const [imgError, setImgError] = useState(false);

  const { user } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ Reset image error whenever the URL changes
  useEffect(() => {
    setImgError(false);
  }, [user?.photoURL]);

  const name = user?.name || 'Your Name';
  const company = user?.companyName || 'Your Company';

  const avatarUrl = useMemo(() => {
    const seed = user?.uid || user?.email || 'site360-user';
    const fallback = `https://i.pravatar.cc/100?u=${encodeURIComponent(seed)}`;
    if (imgError) return fallback;
    if (user?.photoURL) return user.photoURL;
    return fallback;
  }, [user?.photoURL, user?.uid, user?.email, imgError]);

  // ✅ determine active tab from route
  const path = location.pathname;
  const active =
    path.includes('/dashboard/profile/billing')
      ? 'billing'
      : path.includes('/dashboard/profile/settings')
      ? 'settings'
      : 'profile';

  return (
    <div className="profile-page">
      <div className="profile-page-profile-header">
        <img
          className="profile-page-profile-avatar"
          src={avatarUrl}
          alt="User"
          referrerPolicy="no-referrer"
          onError={() => setImgError(true)}
        />

        <div className="profile-page-profile-name-company">
          <h1 className="profile-page-profile-name">{name}</h1>
          <p className="profile-page-profile-company">{company}</p>
        </div>
      </div>

      <div className="profile-page-profile-tabs">
        <button
          className={active === 'profile' ? 'active' : ''}
          onClick={() => navigate('/dashboard/profile')}
        >
          <FaUser /> Profile
        </button>

        <button
          className={active === 'settings' ? 'active' : ''}
          onClick={() => navigate('/dashboard/profile/settings')}
        >
          <FaCog /> Settings
        </button>

        <button
          className={active === 'billing' ? 'active' : ''}
          onClick={() => navigate('/dashboard/profile/billing')}
        >
          <FaCreditCard /> Billing
        </button>
      </div>

      <div className="profile-page-profile-tab-content">
        <Outlet />
      </div>
    </div>
  );
};

export default ProfilePage;
